import { IRideTableDto } from "./ride.dto";

export const getRidesPassengersCount = (
  rows: IRideTableDto[] | undefined,
): number => {
  if (!rows?.length) {
    return 0;
  }

  return rows.reduce(
    (prev, cur) => prev + Number(cur.metadata?.passengersCount || 0),
    0,
  );
};

export const getRidesSeatsCount = (
  rows: IRideTableDto[] | undefined,
): number => {
  if (!rows?.length) {
    return 0;
  }

  return rows.reduce(
    (prev, cur) => prev + Number(cur.metadata?.seatsCount || 0),
    0,
  );
};

export const getRidesTotalAmount = (
  rows: IRideTableDto[] | undefined,
): number => {
  if (!rows?.length) {
    return 0;
  }

  return rows.reduce((prev, cur) => prev + (cur.price || 0), 0);
};

export const getPassengersString = (dto: IRideTableDto): string => {
  const passengers = dto?.metadata?.passengersInfo?.reduce(
    (cur, next) =>
      `${cur}${cur ? "," : ""}${next.lastName || ""} ${next.firstName || ""}`,
    "",
  );
  return passengers || "";
};
